export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10093.1e3d2d03.jpg";